import React, { useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { updateNumberManagement } from '../../../../store/NumberManagementSlice';

const LegalState: React.FC<any> = (props) => {
  const { openCancelModal, handleCancelRequest, openCancelData, getList } =
    props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const state = [
    { label: 'NONE', value: 'NONE' },
    { label: 'EXISTS', value: 'EXISTS' },
  ];

  const fullRange = [
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' },
  ];

  useEffect(() => {
    if (openCancelData) {
      form.setFieldValue('phone_number', openCancelData?.phone_number);
      form.setFieldValue('state', openCancelData?.legal);
    }
  }, [openCancelData, form]);

  const handleSubmit = (data) => {
    dispatch(updateNumberManagement(data))
      .then(() => {
        handleCancelRequest();
        getList();
        form.resetFields();
      })
      .catch(() => {
        handleCancelRequest();
        form.resetFields();
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <Modal
        open={openCancelModal}
        destroyOnClose
        width={800}
        onCancel={handleCancelRequest}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className='addModal'
        title={`Legal State Request`}>
        <FormBox
          className='filterForm'
          form={form}
          onFinish={handleSubmit}
          onChange={handleChange}
          validateTrigger={['onBlur', 'onInput']}
          autoComplete='off'>
          <Row gutter={20} align={'top'}>
            <Col xs={24} md={12} lg={12} xl={12}>
              <InputBox.Text
                label='Phone Number'
                name={'phone_number'}
                disabled
                required
                rules={[validations.required.text('Phone Number')]}
              />
            </Col>
            <Col xs={24} md={12} lg={12} xl={12}>
              <InputBox.Select
                label='State'
                name={'state'}
                allowClear
                placeholder='Select State'
                showSearch
                // initialValue={''}
                options={{
                  list: state && state,
                  valueKey: 'value',
                  textKey: 'label',
                }}
                rules={[validations.required.select('State')]}
              />
            </Col>
            <Col xs={24} md={24} lg={24} xl={24}>
              <InputBox.Select
                label='Full Range'
                name={'full_range'}
                allowClear
                placeholder='Select Full Range'
                showSearch
                // initialValue={''}
                options={{
                  list: fullRange && fullRange,
                  valueKey: 'value',
                  textKey: 'label',
                }}
                rules={[validations.required.select('Full Range')]}
              />
            </Col>
            <Col xs={24} md={12} lg={12} xl={12}>
              {/* <Form.Item label=' '> */}
              <Button type='primary' htmlType='submit'>
                Submit
              </Button>
              {/* </Form.Item> */}
            </Col>
          </Row>
        </FormBox>
      </Modal>
    </>
  );
};

export default LegalState;
